export function isRemoteHttpUrl(url) {
  return /^https?:\/\//i.test(String(url || "").trim());
}

export function pickRemoteHttpUrl(candidates) {
  if (!Array.isArray(candidates)) return "";
  return candidates.find((url) => isRemoteHttpUrl(url)) || "";
}
